import { render, staticRenderFns } from "./DetailData.vue?vue&type=template&id=b95e203a&scoped=true"
import script from "./DetailData.vue?vue&type=script&lang=js"
export * from "./DetailData.vue?vue&type=script&lang=js"
import style0 from "./DetailData.vue?vue&type=style&index=0&id=b95e203a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95e203a",
  null
  
)

export default component.exports